<script setup>
  import AppSidebar from "@/components/App/Sidebar/AppSidebar.vue";
  import { computed, ref } from "vue";
  import { Menu, PieChart, Users, Pen, LayoutGrid, Megaphone, CircleDollarSign, Zap, History } from "lucide-vue-next";
  import { userType } from "@utils/constants/userRoles";
  import { useRoute } from "vue-router";
  import { storeToRefs } from "pinia";
  import { useCurrentUserStore } from "@stores/currentUser.js";
  import { useMCampaignStore } from "@stores/mCampaign";
  const { user } = storeToRefs(useCurrentUserStore());
  const mCampaignStore = useMCampaignStore();
  const { currentMCampaign } = storeToRefs(mCampaignStore);

  const token = computed(() => currentMCampaign.value?.token);

  const route = useRoute();

  const hasAdminRole = [userType.ADMIN, userType.SUPER_ADMIN].includes(user.value?.user_type);

  const navigation = computed(() => [
    {
      title: "General",
      isOpen: ref(true),
      items: [
        {
          title: "Setup",
          url: `/admin/m_campaigns/${token.value}/setup`,
          icon: Menu,
          isActive: !!route.path.match(/^\/admin\/m_campaigns\/(.*)\/setup/),
          if: hasAdminRole,
        },
        {
          title: "Targets & Quotas",
          url: `/admin/m_campaigns/${token.value}/objectives/targets`,
          icon: PieChart,
          isActive: !!route.path.match(/^\/admin\/m_campaigns\/(.*)\/objectives\/targets/),
          if: hasAdminRole,
        },
      ],
    },
    {
      title: "Design",
      isOpen: ref(true),
      items: [
        {
          title: "Audiences",
          url: `/admin/m_campaigns/${token.value}/design/audiences`,
          icon: Users,
          isActive: !!route.path.match(/^\/admin\/m_campaigns\/(.*)\/design\/audiences/),
          if: hasAdminRole,
        },
        {
          title: "Creatives",
          url: `/admin/m_campaigns/${token.value}/design/creatives`,
          icon: Pen,
          isActive: !!route.path.match(/^\/admin\/m_campaigns\/(.*)\/design\/creatives/),
          if: hasAdminRole,
        },
        {
          title: "Creatives overview",
          url: `/admin/m_campaigns/${token.value}/design/overview`,
          icon: LayoutGrid,
          isActive: !!route.path.match(/^\/admin\/m_campaigns\/(.*)\/design\/overview/),
          if: hasAdminRole,
        },
        {
          title: "Campaigns",
          url: `/admin/m_campaigns/${token.value}/design/ads`,
          icon: Megaphone,
          isActive: !!route.path.match(/^\/admin\/m_campaigns\/(.*)\/design\/ads/),
          if: hasAdminRole,
        },
      ],
    },
    {
      title: "Pilot",
      isOpen: ref(true),
      items: [
        {
          title: "Budgets",
          url: `/admin/m_campaigns/${token.value}/budgets`,
          icon: CircleDollarSign,
          isActive: !!route.path.match(/^\/admin\/m_campaigns\/(.*)\/budgets/),
          if: hasAdminRole,
        },
        {
          title: "Actions",
          url: `/admin/m_campaigns/${token.value}/actions`,
          icon: Zap,
          isActive: !!route.path.match(/^\/admin\/m_campaigns\/(.*)\/actions/),
          if: hasAdminRole,
        },
        {
          title: "Push history",
          url: `/admin/m_campaigns/${token.value}/pushes`,
          icon: History,
          isActive: !!route.path.match(/^\/admin\/m_campaigns\/(.*)\/pushes/),
          if: hasAdminRole,
        },
      ],
    },
  ]);
</script>

<template>
  <AppSidebar
    :navigation="navigation"
    :back="{ label: 'Campaigns', to: '/admin/m_campaigns' }" />
</template>
